import i18next from 'i18next';
import { getDefaultAccess } from './defaultAccess';
// import { useQueryClient } from '@tanstack/react-query';

export const hospitalInfo = getDefaultAccess();

export const bundleKey = [
  'userBundles',
  i18next.language,
  hospitalInfo?.tenantId,
  hospitalInfo?.networkId,
  hospitalInfo?.hospitalId,
];

// export const userBundles: any = useQueryClient().getQueryData(bundleKey);

export const takeCorrectBundle = (
  userBundles: [{ bundleId: number }],
  userBundle: number,
) => {
  if (!userBundles) return null;

  return userBundles?.find(({ bundleId }) => bundleId === userBundle);
};
export const generateBundleIdsQueries = (bundleIds: string[]) => {
  return bundleIds?.map((id) => `BundlesIds=${id}`).join('&');
};

export const defaultBundlesId = [
  process.env.NEXT_PUBLIC_BUNDLES_BASIC,
  process.env.NEXT_PUBLIC_BUNDLES_STANDARD,
  process.env.NEXT_PUBLIC_BUNDLES_PHARMACY,
];
